// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ExperimentFilledSvg from "@fishx/icons-svg/es/asn/ExperimentFilled";
import FishxIcon from '../components/FishxIcon';

var ExperimentFilled = function ExperimentFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ExperimentFilledSvg
  }));
};

ExperimentFilled.displayName = 'ExperimentFilled';
export default React.forwardRef(ExperimentFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ExperimentFilled.js
// module id = 2644
// module chunks = 0